"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BaseReviewTemplateFormModel () {
        return BaseReviewTemplateFormModel;
    },
    get EasyAddReviewTemplateFormModel () {
        return EasyAddReviewTemplateFormModel;
    },
    get ExternalReviewTemplateFormModel () {
        return ExternalReviewTemplateFormModel;
    },
    get InternalReviewTemplateFormModel () {
        return InternalReviewTemplateFormModel;
    },
    get ReviewTemplateFormModel () {
        return ReviewTemplateFormModel;
    },
    get ReviewTemplateModel () {
        return ReviewTemplateModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _review = require("../review");
const _reviewformassignment = require("./review-form-assignment");
const BaseReviewTemplateFormModel = _zod.z.object({
    id: _zod.z.instanceof(_bson.ObjectId).optional(),
    /**
	 * @deprecated Use form_base_id instead. Points to review_form._id (version-specific)
	 */ form_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    /**
	 * New. This will replace `form_id` and instead will be used to track the
	 * corresponding review form's `base_id`.
	 */ form_base_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    visible: _zod.z.boolean(),
    redacted: _zod.z.boolean(),
    deleted_at: _zod.z.date().optional(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    basic: _zod.z.boolean().optional(),
    easy_add: _zod.z.boolean().optional(),
    external: _zod.z.boolean().optional()
});
const BaseReviewTemplateFormDueDatesModel = _zod.z.object({
    /**
	 * @deprecated If present, use as fallback for days_to_complete_authors and days_to_complete_signers
	 */ days_to_complete: _zod.z.number().optional(),
    days_to_complete_authors: _zod.z.number(),
    days_to_complete_signers: _zod.z.number()
});
const InternalReviewTemplateFormModel = BaseReviewTemplateFormModel.extend(BaseReviewTemplateFormDueDatesModel.shape).extend({
    basic: _zod.z.literal(true),
    easy_add: _zod.z.literal(false).optional(),
    external: _zod.z.literal(false).optional(),
    authors: _zod.z.array(_reviewformassignment.ReviewAssignmentAuthor).optional(),
    /**
	 * @deprecated If present, prepend to authors array if not already included
	 */ author: _reviewformassignment.ReviewAssignmentAuthor.nullable().optional(),
    signers: _zod.z.array(_reviewformassignment.ReviewAssignmentSigner).optional(),
    /**
	 * @deprecated If present, prepend to signers array if not already included
	 */ signer: _reviewformassignment.ReviewAssignmentSigner.nullable().optional()
});
const EasyAddReviewTemplateFormModel = BaseReviewTemplateFormModel.extend(BaseReviewTemplateFormDueDatesModel.shape).extend({
    basic: _zod.z.literal(false).optional(),
    easy_add: _zod.z.literal(true),
    external: _zod.z.literal(false).optional(),
    /**
	 * @deprecated Use who_can_easy_add instead
	 */ who_can_add: _zod.z.object({
        admin_or_group_admin: _zod.z.boolean().optional(),
        any_employee: _zod.z.boolean().optional(),
        manager_or_chain_of_command: _zod.z.boolean().optional(),
        subject: _zod.z.boolean().optional()
    }).optional(),
    who_can_easy_add: _zod.z.enum([
        "admin",
        "any-employee",
        "manager-chain-of-command",
        "subject"
    ]).optional(),
    subject_employee_choose_author: _zod.z.enum([
        "any-employee",
        "self"
    ]).optional(),
    requires_approval: _zod.z.enum([
        "managers-and-admins",
        "admins-only"
    ]).nullable().optional(),
    allow_comments: _zod.z.boolean().optional(),
    is_active: _zod.z.boolean().optional(),
    signers: _zod.z.array(_reviewformassignment.ReviewAssignmentSigner).optional(),
    /**
	 * @deprecated If present, prepend to signers array if not already included
	 */ signer: _reviewformassignment.ReviewAssignmentSigner.nullable().optional()
});
const ExternalReviewTemplateFormModel = BaseReviewTemplateFormModel.extend({
    basic: _zod.z.literal(false).optional(),
    easy_add: _zod.z.literal(false).optional(),
    external: _zod.z.literal(true),
    author_objects: _zod.z.array(_review.ExternalReviewAuthor).optional(),
    /**
	 * @deprecated If present, prepend to author_objects array if not already included
	 */ author: _review.ExternalReviewAuthor.nullable().optional()
});
const ReviewTemplateFormModel = _zod.z.union([
    ExternalReviewTemplateFormModel,
    InternalReviewTemplateFormModel,
    EasyAddReviewTemplateFormModel
]);
const ReviewTemplateModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    forms: _zod.z.array(ReviewTemplateFormModel),
    // Timestamps
    created_at: _zod.z.date().optional(),
    created_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    last_update: _zod.z.date().optional(),
    updated_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    // Last opened tracking
    last_opened_at: _zod.z.date().optional(),
    last_opened_by: _zod.z.instanceof(_bson.ObjectId).optional(),
    // Soft delete
    deleted_at: _zod.z.date().optional(),
    deleted_by: _zod.z.instanceof(_bson.ObjectId).optional()
});
